import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

// 1. Import the CartProvider
import { CartProvider } from './context/CartContext';   // ← adjust path if needed

const root = ReactDOM.createRoot(document.getElementById('root'));
console.error = () => {};
console.warn = () => {};
console.log = () => {};
console.info = () => {};
root.render(
  <React.StrictMode>
    {/* 2. Wrap the entire app with CartProvider */}
    <CartProvider>
      <App />
    </CartProvider>
  </React.StrictMode>
);


reportWebVitals();